export function filterAuthorizedMenuItems(cookieRequirements) {
    return (a) => {
        const newGroup = {};
        Object.keys(a)
            .filter((key) => {
            const item = a[key];
            return item.scopeRequirements(cookieRequirements);
        })
            .forEach((newKey) => {
            newGroup[newKey] = a[newKey];
        });
        return newGroup;
    };
}
export const userApps = {
    buy: {
        service: "offer",
        path: "buyer",
        scopeRequirements: (scopes) => scopes.some((c) => c.service === "offer" && c.scopes.includes("BY")),
        icon: "https://assets.21real.estate/app_icons/app_buy.svg",
    },
    portfolioAnalyse: {
        service: "portfolio-analyse",
        scopeRequirements: (scopes) => scopes.some((c) => c.service === "portfolio" && c.scopes.includes("S")),
        path: "",
        icon: "https://assets.21real.estate/app_icons/app_portfolioanalysis.svg",
    },
    locationAnalytics: {
        service: "lana",
        scopeRequirements: (scopes) => scopes.some((c) => c.service === "lana" && c.scopes.filter((_) => _ != "CA").length > 0),
        path: "",
        icon: "https://assets.21real.estate/app_icons/app_location_analytics.svg",
    },
    valuation: {
        service: "valuation",
        scopeRequirements: (scopes) => scopes.some((c) => c.service === "valuation" && c.scopes.includes("S")),
        path: "",
        icon: "https://assets.21real.estate/app_icons/app_valuation.svg",
    },
    admin: {
        service: "lana",
        path: "company/settings",
        scopeRequirements: (scopes) => scopes.some((c) => c.scopes.includes("S")),
        icon: "https://assets.21real.estate/app_icons/app_management.svg",
    },
};
//# sourceMappingURL=app-authorization.js.map